import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import ScrollTopButton from "./ScrollTopButton";

export default function Layout() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-background-950">
      <Navbar />
      <main className="flex-1 pt-16 md:pt-[68px]">
        <Outlet />
      </main>
      <Footer />
      <ScrollTopButton />
    </div>
  );
}